import { render, staticRenderFns } from "./VeJwTjJigeList.vue?vue&type=template&id=8594b62e&scoped=true"
import script from "./VeJwTjJigeList.vue?vue&type=script&lang=js"
export * from "./VeJwTjJigeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8594b62e",
  null
  
)

export default component.exports